<template>
    <landing>
        <v-container>
            <v-row>
                <v-col>
                    <div
                        :class="{
                            'display-2': $vuetify.breakpoint.mdAndUp,
                            'display-1': $vuetify.breakpoint.smAndDown,
                        }"
                        class="font-weight-bold mt-6"
                    >
                        Seleccione el plan que desee contratar
                    </div>

                    <slot name="options"></slot>
                    <!-- <div class="mt-5 headline">Selecciona un plan</div> -->
                    <v-form v-model="valid" style="width: 100%" @submit.prevent="submit_func">
                        <v-radio-group v-model="service_plan" :rules="requiredRule">
                            <v-container>
                                <v-row>
                                    <v-col offset-md="1" md="10">
                                        <v-card
                                            :elevation="
                                                service_plan && service_plan == plan.id
                                                ? 10
                                                : 2
                                            "
                                            color="transparent"
                                            class="plans d-flex justify-space-around mb-5"
                                            v-for="plan in contract_types"
                                            :key="plan.id"
                                            @click="selectPlan(plan.id)"
                                        >
                                            
                                            <div 
                                                class="flex-grow-1 d-flex align-center"
                                            >
                                                <v-radio :value="plan.id"/>
                                            </div>
                                            <div 
                                                class="flex-grow-1 d-flex align-center"
                                            >
                                                <span>
                                                    Hasta {{ plan.docs_num.toLocaleString() }} docs/año
                                                </span>
                                            </div>
                                            <div 
                                                class="flex-grow-1 d-flex align-center"
                                            >
                                                <span>Usuarios ilimitados</span>
                                            </div>
                                            <div 
                                                class="flex-grow-1 d-flex align-center"
                                            >
                                                <span>Gestión documental</span>
                                            </div>
                                            <div
                                                class="flex-grow-1 d-flex align-center headline"
                                                :class="{
                                                    selected: plan.id === service_plan,
                                                }"
                                            >
                                                <span v-if="plan.duration.split(' ')[0] == '365'">{{ plan.price }} €/año</span>
                                                <span v-else> {{ plan.price }} €/{{ plan.duration.split(' ')[0] }} días</span>
                                            </div>
                                        </v-card>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-radio-group>
                        
                        <v-row>
                            <v-col cols="5"></v-col>
                            <v-col cols="7">
                                <div class="font-weight-bold display-1">
                                    Fecha de fin del contrato: {{end_date}}
                                </div>
                            </v-col>
                            <!-- <v-col cols="2">
                                <v-text-field
                                    solo
                                    v-model="end_date"
                                    :readonly="true"
                                    label="Final del contrato"
                                ></v-text-field>
                            </v-col> -->
                        </v-row>
                        <v-row class="mt-2">
                            <v-col cols="12" offset-md="10" md="2">

                                <slot name="quiet"></slot>

                                <v-btn
                                    :disabled="!valid || submitting"
                                    block
                                    color="secondary"
                                    @click="submitCreate"
                                >
                                    Contratar
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-col>
            </v-row>
        </v-container>
    </landing>
</template>

<script>
    import Landing from "@/components/layout/Landing";
    import { mapActions, mapGetters } from "vuex";
    // import { STATUS } from "../store/modules/me";
    import { mapFields } from 'vuex-map-fields';
    import { client } from '../api/client';

    export default {
        name: "CreateUpgrateContract",
        components: {
            Landing,
        },

        data() {
            return {
                title: ["Seleccione el plan que desee contratar", "¿A qué plan desea actualizar él actual?"],

                submitting: false,

                valid: false,

                requiredRule: [(v) => Boolean(v) || "required"],

                contract: {},

                payment_method: null,
            };
        },
        created() {
            this.service_plan = undefined;
            this.getContractTypes()
            this.refreshUserData().then(() => {
                for (let i in this.userData.contracts) {
                    if (this.userData.contracts[i]['is_actualizable']) {
                        this.contract = this.userData.contracts[i];
                    }
                }
            });
        },

        methods: {
            selectPlan(id) {
                this.service_plan = id;
            },
            async submitCreate() {
                this.submitting = true;
                try {
                    let response = undefined;
                    if (this.contract.is_trial) {
                        response = await this.upgradeTrialContract();
                    } else {
                        response = await this.createContract();
                    }
                    let payment_params = new URLSearchParams();
                    payment_params.append("amount", response['price'])
                    client.get('get_paycomet_uri', { params: payment_params }).then(response => {
                        let paycometURI = response['data']['uri']

                        this.submitting = false;
                        window.open(paycometURI, "_self")
                        // window.open(paycometURI)
                    })

                } catch (error) {
                    this.submitting = false;
                    console.error(error);
                } finally {
                    // this.submitting = false;
                    // this.$router.push({ name: "document-list" });
                }
            },
            async submitUpgrade() {
                this.submitting = true;
                try {
                    await this.upgradeContract();
                    let payment_params = new URLSearchParams();
                    payment_params.append("amount", (this.selected_contract.price - this.contract.contract_type.price) * 100);
                    client.get('get_paycomet_uri', { params: payment_params }).then(response => {
                        let paycometURI = response['data']['uri'];
                        this.submitting = false;
                        window.open(paycometURI, "_self");
                        // window.open(paycometURI)
                    })
                } catch (error) {
                    this.submitting = false;
                    console.error(error);
                } finally {
                    // this.submitting = false;
                    // this.$router.push({ name: "document-list" });
                }
            },
            submit_func() {
                this.submitCreate()
            },

            ...mapActions({
                refreshUserData: "me/refreshUserData",
                getContractTypes: "contracts/getContractTypes",
                createContract: "contracts/createContract",
                upgradeContract: "contracts/upgradeContract",
                upgradeTrialContract: "contracts/upgradeTrialContract",
            }),
        },
        computed: {
            ...mapGetters({
                userData: "me/userData",
            }),
            ...mapFields('contracts', ['contract_types', 'service_plan']),
            selected_contract() {
                for (let i in this.contract_types) {
                    if (this.service_plan == this.contract_types[i].id) {
                        return this.contract_types[i];
                    }
                }
                return null;
            },
            end_date() {
                let end_date = '';
                const today = new Date();
                const dd = String(today.getDate()).padStart(2, '0');
                const mm = String(today.getMonth() + 1).padStart(2, '0');
                const yyyy = today.getFullYear();
                end_date = dd + '/' + mm + '/' + (yyyy + 1);
                return end_date;
            }
        },
    };
</script>

<style lang="scss" scoped>
    .plans div {
        cursor: pointer;
        background-color: #3cf;
        color: white;
        width: 100%;
        margin: 10px;
        padding: 2px 10px;
        font-weight: bold;
        border-radius: 5px;
        &.selected {
            background-color: yellow;
            color: #3cf;
        }
        &.disabled {
            opacity: 50%;
        }
        &:first-child {
            background-color: transparent;
        }
        span {
            margin: auto;
        }
    }
</style>
